import React from "react";
import {
  WhmIconButton,
  WhmMenu,
  WhmDivider,
  WhmBox,
} from "@securitize/reactjs-whm";
import { PostMailMenuItem } from "./PostMailMenuItem";
import { DownloadMenuItem } from "./DownloadMenuItem";
import { DocumentDto, DocumentType } from "../../../../../data/types";

interface MenuProps {
  document: DocumentDto;
  isMobile?: boolean;
}

export const Menu: React.FC<MenuProps> = ({ document, isMobile = false }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems: React.ReactNode[] = [];

  if (document.type === DocumentType.MONTHLY_STATEMENT) {
    menuItems.push(<PostMailMenuItem key="postmail" isMobile={isMobile} />);
  }

  if (isMobile) {
    menuItems.push(<DownloadMenuItem key="download" document={document} />);
  }

  return (
    <WhmBox
      sx={
        isMobile ? { display: "flex", justifyContent: "flex-end" } : undefined
      }
    >
      <WhmIconButton
        color={"default"}
        size="small"
        id="basic-button"
        disabled={!menuItems.length}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <i className="wh-icon-more-options" />
      </WhmIconButton>
      <WhmMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {menuItems.length > 0 &&
          menuItems.map((item, index) => (
            <React.Fragment key={index}>
              {item}
              {index < menuItems.length - 1 && <WhmDivider />}
            </React.Fragment>
          ))}
      </WhmMenu>
    </WhmBox>
  );
};
